import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';

export const magicstoreFwdx10000Giveaway: Story = {
  id: 'magicstore-fwdx-10000-giveaway',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store FWDX 10000 giveaway',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Web3 App Giveaway: Win $10,000 with FWDX Campaign',
      description:
        'Dive into the world of Web3 apps at Magic Store by Magic Square. Join our FWDX campaign for a chance to win a $10,000',
      keywords:
        'Web3, Crypto, Giveaway, Magic Store, Magic Square, FWDX Campaign, $10,000 prize, Web3 App Store, Decentralized Apps, Crypto Rewards, Blockchain, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: '5b6e0e0b6e4f6bc34309a3c311aa4304f732',
      scode: 'MagicSquare',
      ccode: 'PzwUPF8Nid',
      // leaderboardId: '650955839126383e40022efc',
    },
  },
};
